<template>
  <img :src="asset('images/logo-leaf-white-small.png')" />
</template>
